import VatEditModal from './VatEditModal'

export default VatEditModal